<div class="flex flex-col p-4 pb-80 scroll-smooth" style="overflow: none; background-color: black">
  <div class="w-full flex flex-col gap-4">
    <div class="flex flex-row pb-4 justify-between items-center">
      <span class="text-center text-white">{{ itemsFilter.length }} / {{ items.length }}</span>
      <button (click)="hideFilter()" aria-label="hide filter pane" matTooltip="hide filter pane" matTooltipPosition="right"
        class="text-nowrap border border-white text-white font-semibold hover:text-white  h-[32px] active:bg-[#ff4d0644] aspect-square active:!border-[#ff4d06] hover:border-white rounded-lg">
        X
      </button>
    </div>

    <button (click)="resetFilters()" aria-label="reset filters" matTooltip="reset filters"
      class="text-nowrap border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 active:bg-[#ff4d0644] active:!border-[#ff4d06] hover:border-white rounded-lg">
      RESET FILTERS
    </button>
  </div>

  <div class="py-8">
    <mat-divider></mat-divider>
  </div>
  <div class="w-full flex flex-col gap-4">
    <!-- component -->
    <button (click)="basicFilter('all')" aria-label="filter by show all" [ngClass]="{
        'bg-[#ff4d0644] ': mainFilter === 'all',
        '!border-[#ff4d06]': mainFilter === 'all'
      }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-lg">
      All
    </button>

    <!-- <button (click)="basicFilter('latest-additions')" aria-label="filter by latest additions" [ngClass]="{
        'bg-[#ff4d0644] ': mainFilter === 'latest-additions',
        '!border-[#ff4d06]': mainFilter === 'latest-additions'
      }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-lg">
      Latest Additions
    </button>
    <button (click)="basicFilter('exclusive-deals')" aria-label="filter by exclusive deals" [ngClass]="{
        'bg-[#ff4d0644] ': mainFilter === 'exclusive-deals',
        '!border-[#ff4d06]': mainFilter === 'exclusive-deals'
      }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-lg">
      Exclusive Deals
    </button> -->

    @if(cat.showNewState){


    <button (click)="basicFilter('brand-new')" aria-label="filter by brand new" [ngClass]="{
        'bg-[#ff4d0644] ': mainFilter === 'brand-new',
        '!border-[#ff4d06]': mainFilter === 'brand-new'
      }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-lg">
      Brand New
    </button>


    <button (click)="basicFilter('used')" aria-label="filter by used" [ngClass]="{
        'bg-[#ff4d0644] ': mainFilter === 'used',
        '!border-[#ff4d06]': mainFilter === 'used'
      }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-lg">
      Used
    </button>

    }


  </div>
  <div class="py-8">
    <mat-divider></mat-divider>
  </div>

  <div class="w-full flex flex-col gap-4">
    <span class="text-lg text-white black-ops_one-regular">PRICE</span>
    <div class="flex flex-row gap-2">
      <button (click)="setPriceSort('LOW')" aria-label="sort price low to high" [ngClass]="{
          'bg-[#ff4d0644]': priceSort === 'LOW',
          '!border-[#ff4d06]': priceSort === 'LOW'
        }" class="flex-1 border border-gray-600 text-white font-semibold hover:text-white py-2 px-1 text-xs whitespace-nowrap active:bg-[#ff4d0644] active:!border-[#ff4d06] hover:border-white rounded-lg text-center">
        LOW
      </button>
      <button (click)="setPriceSort('LATEST')" aria-label="sort latest added first" [ngClass]="{
          'bg-[#ff4d0644]': priceSort === 'LATEST',
          '!border-[#ff4d06]': priceSort === 'LATEST'
        }" class="flex-1 border border-gray-600 text-white font-semibold hover:text-white py-2 px-1 text-xs whitespace-nowrap active:bg-[#ff4d0644] active:!border-[#ff4d06] hover:border-white rounded-lg text-center">
        Latest
      </button>
      <button (click)="setPriceSort('HIGH')" aria-label="sort price high to low" [ngClass]="{
          'bg-[#ff4d0644]': priceSort === 'HIGH',
          '!border-[#ff4d06]': priceSort === 'HIGH'
        }" class="flex-1 border border-gray-600 text-white font-semibold hover:text-white py-2 px-1 text-xs whitespace-nowrap active:bg-[#ff4d0644] active:!border-[#ff4d06] hover:border-white rounded-lg text-center">
        HIGH
      </button>
    </div>
  </div>
  <div class="py-8">
    <mat-divider></mat-divider>
  </div>

  <div class="w-full flex flex-col gap-4">
    <span class="text-lg text-white black-ops_one-regular">AVAILABILITY</span>

    <div class="w-full flex flex-col gap-4">
      <!-- component -->
      <button (click)="pushOrRemoveAvailability('IN_STOCK')" aria-label="filter by in stock" [ngClass]="{
          'bg-[#ff4d0644] ': isAvaiItemAdded('IN_STOCK'),
          '!border-[#ff4d06]': isAvaiItemAdded('IN_STOCK')
        }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-full">
        In Supply
      </button>
      <button (click)="pushOrRemoveAvailability('OUT_OF_STOCK')" aria-label="filter by out of stock" [ngClass]="{
          'bg-[#ff4d0644] ': isAvaiItemAdded('OUT_OF_STOCK'),
          '!border-[#ff4d06]': isAvaiItemAdded('OUT_OF_STOCK')
        }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-full">
        Sold Out
      </button>
      <button (click)="pushOrRemoveAvailability('PRE_ORDER')" aria-label="filter by early reservations" [ngClass]="{
          'bg-[#ff4d0644] ': isAvaiItemAdded('PRE_ORDER'),
          '!border-[#ff4d06]': isAvaiItemAdded('PRE_ORDER')
        }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-full">
        Early Reservation
      </button>
    </div>
  </div>

  <div class="w-full flex flex-col gap-4" *ngFor="let item of cat!.filters!; let i = index">
    <div class="py-8">
      <mat-divider></mat-divider>
    </div>

    <span class="text-lg text-white black-ops_one-regular">{{
      item.label
      }}</span>

    <button *ngFor="let fitem of item.filterItems; let i = index" (click)="pushOrRemoveFilter(item.label!, fitem.label!)"
      [attr.aria-label]="'filter by ' + fitem.label" [ngClass]="{
        'bg-[#ff4d0644] ': isFilterItemAdded(item.label!, fitem.label!),
        '!border-[#ff4d06]': isFilterItemAdded(item.label!, fitem.label!)
      }" class="border border-gray-600 text-white font-semibold hover:text-white py-2 px-4 hover:border-white rounded-full">
      {{ fitem.label }}
    </button>
  </div>
</div>